import { useTranslation } from 'react-i18next';

import { useCatalog } from '../../queries';
import type { CatalogKind } from '../../types';
import type { FontIconName } from '@/shared/ui/atoms/FontIcon';
import { Select } from '@/shared/ui/atoms/Select';

type Props = { kind: CatalogKind; id: string; value: string; onChange: (value: string) => void };

const ICON: Record<CatalogKind, FontIconName> = { 'member-types': 'users', 'contract-types': 'file-text2' };

/** A member type or contract type from the organisation's catalogue (optional, informative). */
export function CatalogSelect({ kind, id, value, onChange }: Props) {
  const { t } = useTranslation(undefined, { keyPrefix: `catalogs.${kind}` });
  const entries = useCatalog(kind);
  const names = entries.data ?? [];
  return (
    <Select icon={ICON[kind]} id={id} value={value} onChange={(e) => onChange(e.target.value)}>
      <option value="">{t('unspecified')}</option>
      {names.map((e) => (
        <option key={e.id} value={e.id}>
          {e.name}
        </option>
      ))}
    </Select>
  );
}
